import * as React from 'react';
import { FC } from 'react';
import {
    useListContext,
    DatagridProps,
    Identifier,
} from 'react-admin';
import { Typography, Avatar, Chip, Button, Card, CardActions, CardContent, Grid, makeStyles, Box } from '@mui/material';


const times = (nbChildren: number, fn: (key: number) => any) => Array.from({ length: nbChildren }, (_, key) => fn(key));

const getColsForWidth = (width: any) => {
    if (width === 'xs') return 1;
    if (width === 'sm') return 2;
    if (width === 'md') return 3;
    if (width === 'lg') return 4;
    return 5;
};

// const LoadingGridList: FC<DatagridProps & { nbItems?: number }> = ({
//     width,
//     nbItems = 14,
// }) => {

//     return (
//         <MuiGridList
//             cellHeight={180}
//             cols={getColsForWidth(width)}
//             sx={{ margin: 0 }}
//         >
//             {' '}
//             {times(nbItems, key => (
//                 <GridListTile key={key}>
//                     <Box sx={{ backgroundColor: "grey", height: '100%', }} />
//                 </GridListTile>
//             ))}
//         </MuiGridList>
//     );

// };

const LoadedGridList: FC<DatagridProps> = () => {
    const { data } = useListContext();
    if (!data) return null;

    return (
        <Box sx={{ mt: 10, ml: 4 }}>
            <Grid container spacing={2}>
                {data?.map((record) => (
                    <Grid item xs={11} md={2}>
                        <Card sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: "center", borderRadius: 10 }}>
                            <CardContent>
                                <Box sx={{ marginTop: 5, marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                                    <Avatar alt="User" sx={{ width: 40, height: 40, color: "white", backgroundColor: "orange" }}>{record?.fullName ? record?.fullName.split(/\s/).reduce((response: any, word: any) => response += word.slice(0, 1), '') : record?.email.charAt(0).toUpperCase()}</Avatar>
                                </Box>
                                <Typography sx={{ fontSize: 14, textAlign: "center", marginTop: 0 }} color="textSecondary" gutterBottom>
                                    {record?.fullName ? record?.fullName : record?.email}
                                </Typography>
                                <Typography sx={{ fontSize: 10, textAlign: "center", marginTop: 1 }} color="textSecondary" gutterBottom>
                                    {record?.email}
                                </Typography>
                                <Box sx={{ textAlign: "center", marginTop: 15, textTransform: "uppercase", mt: 8 }}>
                                    <Chip size="medium" label={record?.role} />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

const GridList = () => {
    return <LoadedGridList />
};

export default (GridList);